<template >
  <!-- About Start -->
    <section id="about" class="about" >
      <div class="about-decor">
        <div class="about-circle1"><img :src='"../assets/images/team1.png"' alt="team1"></div>
        <div class="about-circle2"><img :src='"../assets/images/main-banner1.png"' alt="banner1"></div>
      </div>
      <div class="container">
        <div class="row ">
          <div class="col-md-5">
            <div class="about-contain">
              <div>
                <h2 class="title">about <span>LiveTrackz</span></h2>
                <p class="caption-about">LiveTrackz is an easy to use loop playback app, with a constantly updated library of loops. Whether you’re trying to add more percussion to your performance, or trying to stay at an exact BPM like we often need to, LiveTrackz will do just that.</p>
                <div class="row sm-mb">
                  <div class="col-6">
                    <ul class="about-style">
                      <li class="abt-hover">
                        <div class="about-icon">
                          <div class="icon-hover">
                            <img :src='"../assets/images/icon1.png"' style="width:24px;height:24px;" alt="easy-to-use">
                          </div>
                        </div>
                        <div class="about-text">
                          <h3>Easy to Use</h3>
                        </div>
                      </li>
                      <li class="abt-hover">
                        <div class="about-icon">
                          <div class="icon-hover">
                            <img :src='"../assets/images/icon3.png"' style="width:24px;height:24px;" alt="easy-sharing">
                          </div>
                        </div>
                        <div class="about-text">
                          <h3>Realtime Setlist Sharing</h3>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div class="col-6">
                    <ul class="about-style">
                      <li class="abt-hover">
                        <div class="about-icon">
                          <div class="icon-hover">
                            <img :src='"../assets/images/icon2.png"' alt="Awesome-Design">
                          </div>
                        </div>
                        <div class="about-text">
                          <h3>Intuitive Design    </h3>
                        </div>
                      </li>
                      <li class="abt-hover">
                        <div class="about-icon">
                          <div class="icon-hover">
                            <img :src='"../assets/images/icon4.png"' style="width:24px;height:24px;" alt="Affordable">
                          </div>
                        </div>
                        <div class="about-text">
                          <h3>Affordable</h3>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="top-margin">
                  <a href="home#feature"><button type="button" class="btn btn-custom theme-color theme-color">view more</button></a>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-7 d-medium-none">
            <div class="about-right">
              <div class="about-phone">
                <img  :src='"../assets/images/aboutus.png"' class="img-fluid" alt="aboutus">
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- About End -->

</template>
<script>
export default {
  name: 'about'
}
</script>



// WEBPACK FOOTER //
// src/components/about.vue